import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'tpl-smiles',
  templateUrl: './tpl-smiles.component.html',
  styleUrls: ['./tpl-smiles.component.sass']
})


export class TplSmilesComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() objColor: any;
  @Input() low_score_label: string;
  @Input() high_score_label: string;

  @Output() nextStep = new EventEmitter<string>();

  constructor() { }

  timer;

  ngOnInit(): void {
  }

  setFormValue(smile_number){
    this.clickColor(smile_number);
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.nextStep.emit('');
    }, 2000);
    this.form.get('value').setValue(smile_number);
  }

  hoverColor(smile_number){
    let smile = document.getElementsByClassName('smile');
    var arr = Array.from(smile).slice(0, smile_number);

    arr.map((smile_area) => {
      smile_area.classList.remove("opacity");
    })
  }

  outColor(smile_number){
    let smile = document.getElementsByClassName('smile');
    var arr = Array.from(smile).slice(0, smile_number);
    
    arr.map((smile_area) => {
      if(!smile_area.classList.contains("click")){
        smile_area.classList.add("opacity");
      }
    })
  }

  clickColor(smile_number){
    let smiles = document.getElementsByClassName('smile');
    var arr = Array.from(smiles); 

    arr.map((smile_area, index) => {
      if(index > smile_number -1){
        smile_area.classList.remove("click");
        smile_area.classList.add("opacity");
      } else{
        smile_area.classList.add("click");
        smile_area.classList.remove("opacity");
      }
    })
  }
}